import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useProfileRestriction } from '@/components/ProfileRestriction/useProfileRestriction';
import { ROUTE_SUBSCRIPTION } from '@/router/routes';

interface Props {
  description: string;
  image: string;
  imageClassName: string;
}

export const JournalMobilePaywallCard: React.FC<Props> = ({
  description,
  image,
  imageClassName,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isRestricted } = useProfileRestriction();

  return (
    <div className="flex items-center gap-3 rounded-xl bg-popover py-6 pl-6 shadow-card contrast:border contrast:border-border">
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <h3 className="text-title-24 text-foreground">
          {t('overview.journals.paywall.title')}
        </h3>
        <p className="text-body-14 text-muted-foreground">
          {description}
          {!isRestricted && (
            <>
              {' '}
              <button
                type="button"
                className="cursor-pointer text-primary"
                onClick={() => navigate(ROUTE_SUBSCRIPTION)}
              >
                {t('overview.ratings.paywall.readMore')}
              </button>
            </>
          )}
        </p>
      </div>
      <img src={image} alt="" className={`shrink-0 ${imageClassName}`} />
    </div>
  );
};
